import type { Action } from 'state/actions';
import { addOrReplaceKey } from 'state/utils/collection';

import type { CompetitionParametersFeedbackState } from '../model';

export function competitionParametersFeedbackReducer(
  state: CompetitionParametersFeedbackState = {},
  action: Action,
): CompetitionParametersFeedbackState {
  switch (action.type) {
    case 'QUOTE_STALE':
      if (!action.hasFormChanged) {
        return state;
      }
      return addOrReplaceKey(state, action.tabId, [{}]);
    case 'MISSED_DEAL_FEEDBACK_REQUESTED':
    case 'QUOTE_REMOVED':
    case 'MISSED_DEAL_COMPETITION_PARAMETER_FEEDBACK_CLEARED':
    case 'MISSED_DEAL_FEEDBACK_RESET':
      return addOrReplaceKey(state, action.tabId, [{}]);
    case 'MISSED_DEAL_COMPETITION_PARAMETER_FEEDBACK_CHANGED': {
      const start = state[action.tabId].slice(0, action.index);
      const end = state[action.tabId].slice(action.index + 1);

      return addOrReplaceKey(state, action.tabId, [...start, action.feedback, ...end]);
    }
    case 'MISSED_DEAL_COMPETITION_PARAMETER_FEEDBACK_REMOVED': {
      const start = state[action.tabId].slice(0, action.index);
      const end = state[action.tabId].slice(action.index + 1);

      const parameters = [...start, ...end];

      return addOrReplaceKey(state, action.tabId, parameters.length === 0 ? [{}] : parameters);
    }

    default:
      return state;
  }
}
